/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Tirth Bharatiya",
  title: "Hello, I'm Tirth",
  subTitle: emoji(
    "A passionate Software Developer 🚀 having an experience of building cloud-native web and mobile applications."
  ),
  // resumeLink:
  //   "https://drive.google.com/file/d/1yCCF8yRX7kEvG7wMiRg29SbyySTBssCz/view?usp=sharing", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/btirth",
  linkedin: "https://www.linkedin.com/in/btirth",
  gmail: "emailtirth@gmail.com",
  leetcode: "https://leetcode.com/btirth",
  // gitlab: "https://gitlab.com/saadpasta",
  // facebook: "https://www.facebook.com/saad.pasta7",
  // medium: "https://medium.com/@saadpasta",
  // stackoverflow: "https://stackoverflow.com/users/10422806/saad-pasta",
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

// const skillsSection = {
//   title: "Skills",
//   subTitle: "",
//   skills: [
    
//   ],

//   /* Make Sure to include correct Font Awesome Classname to view your icon
// https://fontawesome.com/icons?d=gallery */

//   softwareSkills: [
//     {
//       skillName: "java",
//       fontAwesomeClassname: "fab fa-java"
//     },
//     {
//       skillName: "JavaScript",
//       fontAwesomeClassname: "fab fa-js"
//     },
//     {
//       skillName: "Swift",
//       fontAwesomeClassname: "fab fa-swift"
//     },
//     {
//       skillName: "Python",
//       fontAwesomeClassname: "fab fa-python"
//     },
//     {
//       skillName: "HTML",
//       fontAwesomeClassname: "fab fa-html5"
//     },
//     {
//       skillName: "CSS",
//       fontAwesomeClassname: "fab fa-css3-alt"
//     },
//     {
//       skillName: "ReactJS",
//       fontAwesomeClassname: "fab fa-react"
//     },
//     {
//       skillName: "NodeJS",
//       fontAwesomeClassname: "fab fa-node"
//     },
//     {
//       skillName: "MongoDB",
//       fontAwesomeClassname: "fas fa-database"
//     },
//     {
//       skillName: "AWS",
//       fontAwesomeClassname: "fab fa-aws"
//     },
//     {
//       skillName: "SQL",
//       fontAwesomeClassname: "fas fa-database"
//     },
//     {
//       skillName: "Docker",
//       fontAwesomeClassname: "fab fa-docker"
//     }
//   ],
//   display: true // Set false to hide this section, defaults to true
// };

const skillsSection = {
  title: "Skills",
  subTitle: "",
  skills: [
    
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "java",
      url: "https://img.icons8.com/fluency/100/java-coffee-cup-logo.png"

    },
    {
      skillName: "JavaScript",
      url: "https://img.icons8.com/color/70/javascript--v1.png"
    },
    {
      skillName: "Swift",
      url: "https://img.icons8.com/color/70/swift.png"
    },
    {
      skillName: "Python",
      url: "https://img.icons8.com/color/70/python--v1.png"
    },
    {
      skillName: "Spring",
      url: "https://img.icons8.com/color/70/spring-logo.png"
    },
    {
      skillName: "SpringBoot",
      url: "https://img.icons8.com/officexs/70/spring-logo.png"
    },
    {
      skillName: "HTML",
      url: "https://img.icons8.com/color/70/html-5--v1.png"
    },
    {
      skillName: "CSS",
      url: "https://img.icons8.com/color/70/css3.png"
    },
    {
      skillName: "SwiftUI",
      url: "https://img.icons8.com/color/70/swiftui.png"
    },
    {
      skillName: "ReactJS",
      url: "https://img.icons8.com/color/70/react-native.png"
    },
    {
      skillName: "NodeJS",
      url: "https://img.icons8.com/fluency/70/node-js.png"
    },
    {
      skillName: "MongoDB",
      url: "https://img.icons8.com/color/70/mongodb.png"
    },
    {
      skillName: "AWS",
      url: "https://img.icons8.com/nolan/70/amazon-web-services.png"
    },
    ,
    {
      skillName: "Google Cloud",
      url: "https://img.icons8.com/color/70/google-cloud.png"
    },
    {
      skillName: "MySQL",
      url: "https://img.icons8.com/color/70/my-sql.png"
    },
    {
      skillName: "PostgreSQL",
      url: "https://img.icons8.com/color/70/postgreesql.png"
    },
    {
      skillName: "Docker",
      url: "https://img.icons8.com/color/70/docker.png"
    },
    {
      skillName: "Kubernetes",
      url: "https://img.icons8.com/color/70/kubernetes.png"
    },
    {
      skillName: "Git",
      url: "https://img.icons8.com/color/70/git.png"
    },
    {
      skillName: "GitHub",
      url: "https://img.icons8.com/color/70/github--v1.png"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "Dalhousie University, Canada",
      logo: require("./assets/images/dalhousie.png"),
      subHeader: "Master of Applied Computer Science",
      duration: "Sep 2023 - Dec 2024",
      // desc: "Participated in the research of XXX and published 3 papers.",
      // descBullets: [
      //   "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      //   "Lorem ipsum dolor sit amet, consectetur adipiscing elit"
      // ]
    },
    {
      schoolName: "Charusat University",
      logo: require("./assets/images/charust.png"),
      subHeader: "Bachelor of Science in Computer Science",
      duration: "June 2018 - April 2022",
      // desc: "Ranked top 10% in the program. Took courses about Software Engineering, Web Security, Operating Systems, ...",
      // descBullets: ["Lorem ipsum dolor sit amet, consectetur adipiscing elit"]
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Frontend/Design", //Insert stack or technology you have experience in
      progressPercentage: "90%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Backend",
      progressPercentage: "70%"
    },
    {
      Stack: "Programming",
      progressPercentage: "60%"
    }
  ],
  displayCodersrank: false, // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
  display: false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    // {
    //   role: "Software Engineer",
    //   company: "Facebook",
    //   companylogo: require("./assets/images/facebookLogo.png"),
    //   date: "June 2018 – Present",
    //   desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
    //   descBullets: [
    //     "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
    //     "Lorem ipsum dolor sit amet, consectetur adipiscing elit"
    //   ]
    // },
    {
      role: "Software (Cloud) Developer Intern",
      company: "Aptum",
      companylogo: require("./assets/images/aptum.png"),
      date: "Sep 2024 – Dec 2024",
    },
    {
      role: "Software Developer",
      company: "Meditab",
      companylogo: require("./assets/images/meditabLogo.jpeg"),
      date: "Dec 2021 – Aug 2023",
    },
      {
        role: "Software Developer Intern",
        company: "Smarkt",
        companylogo: require("./assets/images/smarkt.jpeg"),
        date: "Jan 2021 – Jun 2021",
      },
    // {
    //   role: "Software Engineer Intern",
    //   company: "Airbnb",
    //   companylogo: require("./assets/images/airbnbLogo.png"),
    //   date: "Jan 2015 – Sep 2015",
    //   desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
    // }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: true // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Projects",
  projects: [
    {
      image: require("./assets/images/skillBridge.png"),
      projectName: "SkillBridge",
      projectDesc: "Developed social media platform aimed at professional networking and mentorship. \nTechnologies used: JavaScript, Node.js, React, MongoDB",
      footerLink: [
        {
          name: "Live",
          url: "https://cs5709-group11.netlify.app"
        },
        {
          name: "Source Code",
          url: "https://github.com/btirth/SkillBridge"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/lostandfound.png"),
      projectName: "LostAndFound",
      projectDesc: "Developed a full-stack web application enabling users to upload found items and claim missing items seamlessly using React, Java, Spring Boot, and MongoDB.\nImplemented CI/CD pipeline using Gitlab, Docker and a university's private server.\nFollowed Test-Driven Development (TDD) approach throughout the backend development process.",
      footerLink: [
        {
          name: "Source Code",
          url: "https://github.com/btirth/LostAndFound"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/thoughts.png"),
      projectName: "Thoughts",
      projectDesc: "Created an iOS thought-sharing application inspired by Twitter, leveraging the MVVM architecture for efficient code structure and maintainability.\nImplemented core features using Swift and SwiftUI, with Firebase handling real-time database, authentication, and data storage.",
      footerLink: [
        {
          name: "Source Code",
          url: "https://github.com/btirth/thoughts"
        }
        //  you can add extra buttons here.
      ]
    },
    // {
    //   image: require("./assets/images/nextuLogo.webp"),
    //   projectName: "Nextu",
    //   projectDesc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
    //   footerLink: [
    //     {
    //       name: "Visit Website",
    //       url: "http://nextu.se/"
    //     }
    //   ]
    // }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  achievementsCards: [
    {
      title: "AWS Certified Solutions Architect – Associate",
      subtitle:
        "",
      image: require("./assets/images/aws-saa.png"),
      imageAlt: "AWS Certified Solutions Architect – Associate",
      footerLink: [
        {
          name: "Certification",
          url: "https://www.credly.com/badges/3867f3da-93b1-4f90-b8bf-7a6268beccb7/public_url"
        }
      ]
    },
    {
      title: "AWS Certified Cloud Practitioner",
      subtitle:
        "",
      image: require("./assets/images/aws-cp.png"),
      imageAlt: "AWS Certified Cloud Practitioner",
      footerLink: [
        {
          name: "Certification",
          url: "https://www.credly.com/badges/4bb80845-1111-428c-b6e0-8bae9e057ae3/public_url"
        }
      ]
    },
    // {
    //   title: "Google Assistant Action",
    //   subtitle:
    //     "Developed a Google Assistant Action JavaScript Guru that is available on 2 Billion devices world wide.",
    //   image: require("./assets/images/googleAssistantLogo.webp"),
    //   imageAlt: "Google Assistant Action Logo",
    //   footerLink: [
    //     {
    //       name: "View Google Assistant Action",
    //       url: "https://assistant.google.com/services/a/uid/000000100ee688ee?hl=en"
    //     }
    //   ]
    // },

    // {
    //   title: "PWA Web App Developer",
    //   subtitle: "Completed Certifcation from SMIT for PWA Web App Development",
    //   image: require("./assets/images/pwaLogo.webp"),
    //   imageAlt: "PWA Logo",
    //   footerLink: [
    //     {name: "Certification", url: ""},
    //     {
    //       name: "Final Project",
    //       url: "https://pakistan-olx-1.firebaseapp.com/"
    //     }
    //   ]
    // },

    // {
    //   title: "PWA Web App Developer",
    //   subtitle: "Completed Certifcation from SMIT for PWA Web App Development",
    //   image: require("./assets/images/pwaLogo.webp"),
    //   imageAlt: "PWA Logo",
    //   footerLink: [
    //     {name: "Certification", url: ""},
    //     {
    //       name: "Final Project",
    //       url: "https://pakistan-olx-1.firebaseapp.com/"
    //     }
    //   ]
    // },

    // {
    //   title: "PWA Web App Developer",
    //   subtitle: "Completed Certifcation from SMIT for PWA Web App Development",
    //   image: require("./assets/images/pwaLogo.webp"),
    //   imageAlt: "PWA Logo",
    //   footerLink: [
    //     {name: "Certification", url: ""},
    //     {
    //       name: "Final Project",
    //       url: "https://pakistan-olx-1.firebaseapp.com/"
    //     }
    //   ]
    // }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: false // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  number: "+1(782)882-7184",
  email_address: "emailtirth@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

const isHireable = false; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable
};
